import { Box } from "@radix-ui/themes";

export function Divider() {
  return (
    <Box
      style={{
        height: "6px",
        backgroundColor: "var(--teal-9)",
        borderRadius: "9999px",
        width: "80px",
        margin: "12px 0",
      }}
    />
  );
}
